import { __extends } from "tslib";
// SA-8637: Sentry loaded from CDN (see src/index.html + src/types/sentry-cdn.d.ts).
import * as React from 'react';
import { Component } from 'react';
var SentryErrorBoundary = /** @class */ (function (_super) {
    __extends(SentryErrorBoundary, _super);
    function SentryErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    SentryErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    SentryErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        // SA-8637: defensive guard — see sentry.utils.ts.
        if (typeof Sentry === 'undefined') {
            return;
        }
        Sentry.captureException(error, {
            tags: {
                source: 'react-error-boundary'
            },
            extra: {
                componentStack: errorInfo.componentStack
            }
        });
    };
    SentryErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (React.createElement("div", { style: { padding: 24, textAlign: 'center', color: '#666' } },
                React.createElement("p", null, "Something went wrong. Please refresh the page and try again.")));
        }
        return this.props.children;
    };
    return SentryErrorBoundary;
}(Component));
export { SentryErrorBoundary };
